import { useQueryClient } from "@tanstack/react-query";

import { useMount } from "app/custom-hooks/useMount";
import { KEYWORDS_AVG_QUERY_KEY } from "app/pages/activation/queries/rankTracker/useGetKeywordsAvgQuery";

import { SHARE_OF_VOICE_QUERY_KEY } from "./useShareOfVoiceWidgetQuery";
import { TRAFFIC_QUERY_KEY } from "./useTrafficWidgetQuery";

export const useShareDataInvalidation = (): void => {
    const queryClient = useQueryClient();

    useMount(() => {
        void queryClient.invalidateQueries({ queryKey: [TRAFFIC_QUERY_KEY] });
        void queryClient.invalidateQueries({ queryKey: [SHARE_OF_VOICE_QUERY_KEY] });
        void queryClient.invalidateQueries({ queryKey: [KEYWORDS_AVG_QUERY_KEY] });
    });
};

